@use '@lib/assets/styles/main.scss' as *;

$imageSize: 40px;
$headerHeight: 66px;

.root {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding-top: $headerHeight;
}

.rootWithTracker {
  position: relative;
}

.rootWithOpenedSidebar {
  position: relative;
}

.content {
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0 auto;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}

.header {
  z-index: $zIndexStickyHeader;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid $gray100;
  background: rgba($gray0, 0.6);
  backdrop-filter: blur(15px);
  padding: 0 16px;
  .rootWithOpenedSidebar & {
    backdrop-filter: unset;
  }
}

.headerLogo {
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
  svg {
    display: block;
    width: 40px;
    height: auto;
  }
}

.headerRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: $headerHeight;
}

.userAvatar {
  img, svg {
    @extend %userAvatarImage;
    width: $imageSize;
    height: $imageSize;
  }
}

.sideBar {
  // Ensure sidebar sits above the overlay
  z-index: $zIndexStickyHeader + 2;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  padding: 12px 0;
  background-color: $gray0;
  width: 240px;
  box-shadow: 0 1px transparent;
  transition: transform 0.2s ease, opacity 0.2s ease;
  &:not(.sideBarVisible) {
    transform: translateX(-100%);
    opacity: 0;
  }
  &.sideBarVisible {
    transform: translateX(0);
    opacity: 1;
  }
}

.sideBarOverlay {
  @extend %overlay;
  // Overlay must cover the whole viewport on iOS and capture touches
  z-index: $zIndexStickyHeader + 1;
  position: fixed;
  inset: 0; // shorthand for top/right/bottom/left: 0;
  transition: opacity 0.2s ease;
  // Disable interactions when hidden to avoid accidental blocks
  pointer-events: none;
  &:not(.sideBarOverlayVisible) {
    transform: translateX(-100%);
    opacity: 0;
  }
  &.sideBarOverlayVisible {
    transform: translateX(0);
    opacity: 1;
    pointer-events: auto;
  }
}

.sideBarTopBlock {
  padding: 0 12px;
  margin-bottom: 32px;
}

.toggleBtn {
  position: absolute;
  left: 100%;
  top: 63px;
  transform: translate(-50%, -50%);
}

.sideBarLogo {
  display: flex;
  align-items: center;
  width: 160px;
  height: 48px;
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
  svg {
    display: block;
    max-width: 100%;
    height: auto;
    margin: 0 auto;
  }
}

.sideBarLogoSmall {
  display: flex;
  align-items: center;
  width: 52px;
  height: 48px;
  padding-bottom: 4px;
  padding-left: 2px;
  svg {
    display: block;
    width: 35px;
    height: auto;
    margin: 0 auto;
  }
}

.menuItemWrapClassName {
  padding: 0 12px;
}
